import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import "./partslist.scss";
import { orderviewAction } from "../../actions/orderviewAction";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import PoppupAck from "../../component/PopupAck";
import { useParams } from "react-router";
import Loader from "../../component/loaderComponent/Loader";
import { safeDecode } from "../../common/decoder";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { dowloadOrderAction } from "../../actions/downloadAction";
import { NotificationManager } from "react-notifications";
import NodataFound from "../../component/NodataFound";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

function Parts_Lists() {
  const { id } = useParams();
  const decodeid = safeDecode(id);
  const handelclick = () => {
    setShow(true);
  }
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const upkey = () => {
    alert("up key")
  }
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false)
  }
  const [orderviewList, setOrderViewList] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [ordernumber, setOrderNumber] = useState("");
  const [pgmname, setPgmname] = useState("");
  const [orderview, setOrderview] = useState([]);
  const [status, setstatus] = useState("")
  const [expandedRows, setExpandedRows] = useState({});
  const toggleRow = (index) => {
    setExpandedRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const navigate = useNavigate();
  const handleCloseButton = () =>{
    navigate(`/partorderlist`);
  }
  useEffect(() => {
    OrderViewListData();
    handleChangeLanguage(language);
  }, []);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  async function downloadOrder() {
    const id = orderview?.id
    try {
      const fileBlob = await dispatch(dowloadOrderAction(id));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          NotificationManager.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      NotificationManager.error('Error downloading file:', error);
    }
  }

  async function OrderViewListData(sortdata, itemid) {
    setIsLoading(true);
    let response = await dispatch(orderviewAction(decodeid, sortdata, itemid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      setOrderNumber(response.data.data.order_number);
      setPgmname(response.data.data.pgm_name);
      setOrderViewList(response.data.data.items)
      setOrderview(response.data.data)
      setstatus(response.data.data?.status)
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  }
  const sortingData = (sortitem, itemid) =>{
    OrderViewListData(sortitem, itemid)
  } 
  const Country_name = safeDecode(Cookies.get('country_name'));

  const renderModelCell = (variants = [], index) => {
    const models = [...new Set(variants.map(p => p?.model_name).filter(Boolean))];
    const isExpanded = expandedRows[index];
    const displayCount = 3;
  
    const visibleModels = isExpanded ? models : models.slice(0, displayCount);
    const hasMore = models.length > displayCount;
  
    return (
      <>
        {visibleModels.join(', ')}
        {hasMore && !isExpanded && (
          <span className="more-link" onClick={() => toggleRow(index)}>
            {t('common.more')}
          </span>
        )}
      </>
    );
  };
  

  return (

    <div className="partslists_containers">
      <div className="partslist_container">
        <div className="partslistmain">
          <div className="header_border tvsparts_text">
            TVS &gt; {t('parts_list.partandorder')} &gt; {ordernumber}
          </div>
          <div className="partslist_catainersorders">
            <div className="partslistcatainersorders">
              <span className="pgm_spacialtext">{ordernumber} | <p className="pgm-name"> {pgmname} </p> | <p className="pgm_spacialtext-para">{t('partorderlist.new')}</p></span>
            </div>
            <div className="parts_listsscatainersorders">
              <button className="AddpartsbulkAddpartsbulk_parts" onClick={handelclick}>
              {t('parts_list.acknowledgeorder')}
              </button>
              {hasPermission(PERMISSIONS.CAN_GENERATE_ORDER_EXCEL) && (
                <button className="dexcel" onClick={downloadOrder}>
                  <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
                  {t('parts_list.downloadorder')}
                </button>
              )}
              <button className="close-btn" onClick={handleCloseButton}>
              {t('addparts.close')}
              </button>
            </div>
          </div>
          <div>
            {isLoading ? (
              <Loader />
            ) : (
              <div className="tabledata">
                {orderviewList?.length > 0 ?
                <table className="table">
                  <tr>
                    <th className="tablesth"> <div className="fangledowndiv">{t('pgmlist.sNo')}
                    </div></th>
                    <th className="tablesth"> <div className="fangledowndiv"> {t('parts_list.itemid')}<div className="fangledownupdiv"><FaAngleUp onClick={() => sortingData("asc", "part_number")} /><FaAngleDown onClick={() => sortingData("desc", "part_number")} /></div></div></th>
                    <th className="tablesth"> <div className="fangledowndiv"> {t('parts_list.itemname')}
                    </div></th>
                    <th className="tablesth">{t('common.vehicleApplicable')}</th>
                    <th className="tablesth"> <div className="fangledowndiv">{t('partlist.price')}</div></th>
                    <th className="tablesth"> <div className="fangledowndiv">{t('parts_list.quantity')}
                    </div></th>
                    <th className="tablesth"> <div className="fangledowndiv">{t('parts_list.discount')}
                    </div></th>
                    <th className="tablesth"> <div className="fangledowndiv">{t('parts_list.netamount')}
                    </div></th>
                  </tr>
                  {orderviewList?.map((data, ind) =>
                    <tr>
                      <td className="tabletdnum">{ind + 1}</td>
                      <td className="tabletd">{data.item_id}</td>
                      <td className="tabletd">{data.name}</td>
                      <td className="tabletd model-name">{renderModelCell(data?.part_variants, ind)}</td>
                      <td className="tabletdnum">{orderview?.currency} {data.price}</td>
                      <td className="tabletdnum">{data.quantity}</td>
                      <td className="tabletdnum">{data.discount}</td>
                      <td className="tabletdnum">{orderview?.currency} {data.discounted_amount}</td>
                    </tr>
                  )}
                  <tr className="totaltable_collumn">
                    <td className="tabletdnum totalSpecialtext">{t('parts_list.total')}</td>
                    <td className="tabletd"></td>
                    <td className="tabletd"></td>
                    <td className="tabletd"></td>
                    <td className="tabletd"></td>
                    <td className="tabletdnum totalSpecialtext"> {orderview?.total_quantity}</td>
                    <td className="tabletdnum totalSpecialtext"></td>
                    <td className="tabletdnum">{orderview?.currency} {orderview?.total_amount}</td>
                  </tr>
                </table>
                :
            <NodataFound/>
              }
              </div>
            )}
            <div>
            </div>
          </div>
          <Modal
            className="expertise-modal montserrat-font"
            show={show}
            onHide={handleClose}
          >
            <Modal.Body className="p-0">
              {show && <PoppupAck decodeid={decodeid} handleClose={handleClose} />}
            </Modal.Body>
          </Modal>
          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Parts_Lists;
